import { DeviceMetadata } from '../../domain/telemetry/raw/RawTelemetryData'
import { Device } from '../apiTypes'

export const UNKNOWN_DEVICE: Readonly<Device> = {
  name: 'Unknown',
  version: '1.0',
}

export const deviceMetadataOf = (device: Device): DeviceMetadata => ({
  deviceName: device.name,
  deviceVersion: device.version,
})
